import PageMainTitle from 'components/commons/PageMainTitle'
import styles from './SecurityPrivacy.module.scss'

interface PageMainTitle {
  titleJa: string
  category: string
  title: string
  sub_title: string
  sub_title2: string
  text: string
}

const SecurityPrivacy: React.FC = () => {
  const paths = [
    { name: 'TOP', url: '/' },
    { name: '情報セキュリティ方針・個人情報保護方針', url: '#' },
  ]

  const pageMainTitle: PageMainTitle = {
    titleJa: '情報セキュリティ方針・個人情報保護方針',
    category: '',
    title: '',
    sub_title: '',
    sub_title2: '',
    text: '',
  }

  return (
    <>
      <PageMainTitle pageMainTitle={pageMainTitle} paths={paths} />
      <article className={styles.privacy_page}>
        <section className={styles.top_group}>
          <h2 className={styles.top_text_title}>情報セキュリティ方針</h2>
          <p className={styles.top_text}>
            当社は、お客さまからお預かりした情報および当社が保有する情報資産を安全に守ることを重要な責任と考え、安心してサービスをご利用いただけるよう、以下の通り情報セキュリティへの取り組みを継続して実施いたします。
          </p>
          <h3 className={styles.privacy_title}>情報セキュリティに関する取り組み</h3>
          <ul className={styles.text_lists}>
            <li className={`${styles.top_text_list} ${styles.first}`}>
              <h4 className={styles.privacy_list_title}>管理体制の整備</h4>
              <p className={styles.list_text}>
                情報セキュリティを管理する体制を整え、組織全体で情報セキュリティの向上に取り組みます。
              </p>
            </li>
            <li className={styles.top_text_list}>
              <h4 className={styles.privacy_list_title}>法令・規範の遵守</h4>
              <p className={styles.list_text}>
                情報セキュリティに関する法令、ガイドライン、およびお客さまとの契約事項を遵守します。
              </p>
            </li>
            <li className={styles.top_text_list}>
              <h4 className={styles.privacy_list_title}>リスクアセスメントの実施</h4>
              <p className={styles.list_text}>
                情報資産へのリスクを定期的に評価し、不正アクセス、紛失、改ざんおよび漏えい等に対して適切な対策を講じます。
              </p>
            </li>
            <li className={styles.top_text_list}>
              <h4 className={styles.privacy_list_title}>教育・研修の実施</h4>
              <p className={styles.list_text}>
                全従業者が情報を適切に扱えるよう、情報セキュリティに関する教育・研修を継続的に実施します。
              </p>
            </li>
            <li className={styles.top_text_list}>
              <h4 className={styles.privacy_list_title}>技術的・物理的対策の実施</h4>
              <p className={styles.list_text}>
                アクセス管理や暗号化などの技術的対策、およびオフィスへの入退室管理等の物理的なセキュリティ対策を実施します。
              </p>
            </li>
            <li className={styles.top_text_list}>
              <h4 className={styles.privacy_list_title}>外部委託先の管理</h4>
              <p className={styles.list_text}>
                業務を外部に委託する場合には、委託先に対しても情報管理の適正を求め、その安全性を継続的に確認します。
              </p>
            </li>
            <li className={styles.top_text_list}>
              <h4 className={styles.privacy_list_title}>事故発生時の対応</h4>
              <p className={styles.list_text}>
                情報漏えい等の事故が発生した場合には、迅速かつ適切に対応し、被害の最小化と再発防止に努めます。
              </p>
            </li>
            <li className={styles.top_text_list}>
              <h4 className={styles.privacy_list_title}>継続的改善</h4>
              <p className={styles.list_text}>
                情報セキュリティへの取り組みを定期的に見直し、情報セキュリティマネジメントシステムの継続的な改善に努めます。
              </p>
            </li>
          </ul>
          <ul className={styles.corpo_group}>
            <li>制定日：2026年2月1日</li>
          </ul>
          <ul className={styles.corpo_group}>
            <li>Aitria株式会社</li>
            <li>代表取締役社長 CEO 芝 陽一郎</li>
          </ul>
          <h3 className={styles.privacy_title}>ISMS認証について</h3>
          <p className={styles.list_text}>
            Aitria株式会社は、情報セキュリティマネジメントシステム（ISMS）の国際規格である「ISO/IEC
            27001:2022」の認証を取得しています。
            <br />
            今後も情報セキュリティ体制の維持・強化を徹底し、すべてのお客様に安心してご利用いただけるサービスの提供に努めてまいります。
          </p>
          <div className={styles.ismsWrapper}>
            <div className={styles.ismsLeft}>
              <figure className={styles.isms__logo}>
                <img
                  src="/img/common/isms.png"
                  alt="ISMS認証ロゴ"
                  width={1024}
                  height={411}
                  className={styles.isms__logo__img}
                />
              </figure>
            </div>
            <div className={styles.ismsRight}>
              <table className={styles.table__isms}>
                <tbody>
                  <tr>
                    <th className={styles.th}>認証規格</th>
                    <td className={styles.td}>ISO/IEC 27001:2022（情報セキュリティマネジメントシステム）</td>
                  </tr>
                  <tr>
                    <th className={styles.th}>認証登録番号</th>
                    <td className={styles.td}>GIJP-2169-IC</td>
                  </tr>
                  <tr>
                    <th className={styles.th}>初回認証日</th>
                    <td className={styles.td}>2026年5月14日</td>
                  </tr>
                  <tr>
                    <th className={styles.th}>適用所在地</th>
                    <td className={styles.td}>
                      Aitria株式会社（Aitria Co., Ltd.）本社
                      <br />
                      〒107-0052 東京都港区赤坂八丁目1番22号 NMF青山一丁目ビル3階
                    </td>
                  </tr>
                  <tr>
                    <th className={styles.th}>適用範囲</th>
                    <td className={styles.td}>
                      ・モダンアプリケーション開発
                      <br />
                      ・デジタルプロダクトデザイン
                      <br />
                      ・プロダクト成長支援
                      <br />
                      ・営業業務
                      <br />
                      ・マーケティング業務
                      <br />
                      ・バックオフィス業務
                    </td>
                  </tr>
                  <tr>
                    <th className={styles.th}>認証機関</th>
                    <td className={styles.td}>株式会社GCERTI-JAPAN</td>
                  </tr>
                  <tr>
                    <th className={styles.th}>認定機関</th>
                    <td className={styles.td}>IAS（International Accreditation Service） MSCB-113</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
        <section className={styles.top_group}>
          <h2 className={styles.top_text_title}>個人情報保護方針</h2>
          <p className={styles.top_text}>
            Aitria株式会社は、AI駆動のデジタルエンジニアリング企業として事業活動を行なっていく上で、お客様の個人情報がプライバシーを構成する重要な情報であることを深く認識し、業務において個人情報を取り扱う場合には、個人情報に関する法令及び個人情報保護のために定めた社内規定を定め、また、組織体制を整備し、個人情報の適切な保護に努めることにより、お客様を尊重し、当社に対する期待と信頼に応えていきます。
          </p>
          <ul className={styles.text_lists}>
            <li className={`${styles.top_text_list} ${styles.first}`}>
              <h4 className={styles.privacy_list_title}>個人情報の取得、利用、提供</h4>
              <p className={styles.list_text}>
                当社は、事業活動の範囲内で個人情報の利用目的を特定し、その目的達成のために必要な限度で公正かつ適正に個人情報の取得、利用及び提供を行います。また、取得した個人情報の目的外利用をしないよう処置を講じます。
              </p>
            </li>
            <li className={styles.top_text_list}>
              <h4 className={styles.privacy_list_title}>法令・規範の遵守</h4>
              <p className={styles.list_text}>
                当社は、個人情報保護法その他の関係法令、国が定めるガイドライン、その他の規範及び社会秩序を遵守し、個人情報の適切な保護に努めます。
              </p>
            </li>
            <li className={styles.top_text_list}>
              <h4 className={styles.privacy_list_title}>個人情報の適切な管理</h4>
              <p className={styles.list_text}>
                当社は、私たちが取り扱う個人情報について、不正アクセス、紛失、破壊、改ざん、漏えいなどの危険を十分に認識し、合理的な安全対策を実施するとともに、問題が発生した場合は適切な是正措置を講じます。
              </p>
            </li>
            <li className={styles.top_text_list}>
              <h4 className={styles.privacy_list_title}>問い合わせへの対応</h4>
              <p className={styles.list_text}>
                当社は、私たちが取り扱う個人情報について、本人から開示、訂正、利用停止及び苦情相談等のお問い合わせがあった場合は適正に対応します。
              </p>
            </li>
            <li className={styles.top_text_list}>
              <h4 className={styles.privacy_list_title}>継続的改善</h4>
              <p className={styles.list_text}>
                当社は、個人情報保護に関する管理規定及び管理体制を整備し、全社員で徹底して運用するとともに定期的な見直しを行い、個人情報保護の管理体制の継続的な改善に努めます。
              </p>
            </li>
          </ul>
          <ul className={styles.corpo_group}>
            <li>2011年12月1日　制定</li>
            <li>2020年11月16日　改定</li>
            <li>2023年11月27日　改定</li>
            <li>2026年7月13日　改定</li>
          </ul>
          <ul className={styles.corpo_group}>
            <li>Aitria株式会社</li>
            <li>代表取締役社長 CEO 芝 陽一郎</li>
          </ul>
          <ul className={styles.contact_group}>
            <li>＜個人情報保護に関する連絡先＞</li>
            <li>個人情報問合せ窓口</li>
            <li>住所　東京都港区赤坂八丁目１番22号 NMF青山一丁目ビル３階</li>
            <li>個人情報保護管理者　大森 康宏</li>
            <li>TEL　03-6419-7700</li>
          </ul>
        </section>
        <section className={styles.privacy_contents}>
          <div className={styles.privacy_group}>
            <h3 className={styles.privacy_title}>当社が取扱う個人情報について</h3>
            <p className={styles.privacy_title_text}>
              当社では「個人情報保護方針」に基づき個人情報の適切な保護に取り組んでいます。当社が事業の用に供するために取得し、または保有する個人情報について、以下の通りお知らせいたします。
            </p>
          </div>
          <ul className={styles.privacy_text_lists}>
            <li className={styles.privacy_list}>
              <h4 className={styles.privacy_list_title}>
                （１）個人情報の取扱事業者の名称及び住所並びに法人にあたってはその代表者の氏名
              </h4>
              <ul className={styles.contact_group_sub}>
                <li>事業者名：Aitria株式会社</li>
                <li>代表取締役：芝 陽一郎</li>
                <li>住所：東京都港区赤坂八丁目１番22号</li>
              </ul>
            </li>
            <li className={styles.privacy_list}>
              <h4 className={styles.privacy_list_title}>
                （２）個人情報保護管理者（若しくはその代理人）の氏名又は職名、所属及び連絡先
              </h4>
              <ul className={styles.contact_group_sub}>
                <li>個人情報保護管理者：大森 康宏</li>
                <li>電子メール：pms_mgmt@aitria.co.jp</li>
                <li>電話番号：03-6419-7700</li>
              </ul>
            </li>
            <li className={styles.privacy_list}>
              <h4 className={styles.privacy_list_title}>（３）個人情報の利用目的</h4>
              <p className={styles.list_text}>
                当社が事業活動において取扱う個人情報の利用目的は、次の通りといたします。
              </p>
              <p className={styles.table_title}>1　保有個人データ</p>
              <table className={styles.table}>
                <thead>
                  <tr className={styles.table_column_title}>
                    <th className={styles.th}>個人情報の種別</th>
                    <th className={styles.th}>利用目的</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th className={styles.th}>当社サービス利用に際し取得される情報</th>
                    <td className={styles.td}>当社提供サービスを顧客企業様、または弊社がサービス提供をするため</td>
                  </tr>
                  <tr>
                    <th className={styles.th}>クライアント情報</th>
                    <td className={styles.td}>
                      <p>当社業務に関する報告、連絡</p>
                      <p>メール・電話などによる当社サービス、セミナーのご案内および、営業活動</p>
                      <p>見積書などの各種営業書類の作成、提出</p>
                      <p>当社サービスの提供のため</p>
                    </td>
                  </tr>
                  <tr>
                    <th className={styles.th}>従業者情報</th>
                    <td className={styles.td}>
                      従業者管理に係わる業務に利用するため（業務・労務・人事管理業務、給与関連業務、福利厚生業務など）
                    </td>
                  </tr>
                  <tr>
                    <th className={styles.th}>採用応募者情報</th>
                    <td className={styles.td}>
                      <p>採用に関するご連絡、ご報告</p>
                      <p>採用判定の基礎資料</p>
                      <p>採用された場合、当社における人事管理に関わる業務のため</p>
                    </td>
                  </tr>
                  <tr>
                    <th className={styles.th}>退職者情報</th>
                    <td className={styles.td}>退職者との連絡、退職者からのお問合せへの対応に利用するため</td>
                  </tr>
                  <tr>
                    <th className={styles.th}>お問い合わせ情報</th>
                    <td className={styles.td}>
                      <p>お問い合わせ内容に関するご回答、ご連絡</p>
                      <p>メール・電話などによる当社サービス、セミナーのご案内および、営業活動のため</p>
                    </td>
                  </tr>
                  <tr>
                    <th className={styles.th}>本人および代理人の情報（開示等請求時）</th>
                    <td className={styles.td}>開示等の求めに回答するため</td>
                  </tr>
                </tbody>
              </table>
              <p className={styles.table_bottom_text}>その他、個別に書面で明示したとおりの利用目的とします。</p>
              <p className={styles.table_title}>2　それ以外取得個人情報</p>
              <table className={styles.table}>
                <thead>
                  <tr className={styles.table_column_title}>
                    <th className={styles.th}>個人情報の種別</th>
                    <th className={styles.th}>利用目的</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th className={styles.th}>受託した業務により取得した個人情報</th>
                    <td className={styles.td}>
                      契約及びそれに伴う連絡、受託業務の遂行、アフターケアなどに利用するため
                    </td>
                  </tr>
                  <tr>
                    <th className={styles.th}>求人サイトから取得した情報</th>
                    <td className={styles.td}>求人者に対する採用の可否を判断・通知するため</td>
                  </tr>
                </tbody>
              </table>
            </li>
            <li className={styles.privacy_list}>
              <h4 className={styles.privacy_list_title}>（４）個人情報に関するお問合せ窓口</h4>
              <p className={styles.list_text}>
                保有個人データに関わるものを含め、個人情報の取扱についての苦情・相談、問合せは、下記の【問合せ窓口】までお申し出ください。
              </p>
              <p className={styles.table_title}>【問合せ窓口】</p>
              <table className={styles.table}>
                <thead>
                  <tr className={styles.table_column_title}>
                    <th className={styles.th}>窓口の名称</th>
                    <td className={styles.td}>個人情報問合せ窓口</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th className={styles.th}>連絡先</th>
                    <td className={styles.td}>
                      <p>
                        <span className={styles.bottom_table_title}>窓口責任者</span>：個人情報保護管理者
                      </p>
                      <p>
                        <span className={styles.bottom_table_title}>住所</span>：〒107-0052 東京都港区赤坂八丁目１番22号
                        NMF青山一丁目ビル３階
                      </p>
                      <p>
                        <span className={styles.bottom_table_title}>電話/FAX</span>：03-6419-7700 / 03-6419-7703
                      </p>
                      <p>
                        <span className={styles.bottom_table_title}>電子メール</span>：pms_mgmt@aitria.co.jp
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </li>
            <li className={styles.privacy_list}>
              <h4 className={styles.privacy_list_title}>
                （５）所属する認定個人情報保護団体の名称および苦情の解決の申し出先
              </h4>
              <p className={styles.list_text}>なし</p>
            </li>
            <li className={styles.privacy_list}>
              <h4 className={styles.privacy_list_title}>（６）開示等の手続について</h4>
              <p className={styles.list_text}>
                当社では、保有個人データに関して、ご本人の開示等（利用目的の通知、開示、内容の訂正、追加又は削除、利用の停止、消去及び第三者への提供の停止、第三者提供記録の開示）の請求に迅速に対応いたします。希望される場合には、お申し出いただいた方がご本人或いはその代理人であることを確認した上で、合理的な期間及び範囲で対応いたします。
              </p>
            </li>
            <li className={styles.privacy_list}>
              <h4 className={styles.privacy_list_title}>（７）開示等の受付方法・窓口</h4>
              <p className={styles.list_text}>
                保有個人データに関する開示等のお申し出は、下記の受付窓口までご連絡ください。ご連絡いただきましたら、当社所定の「保有個人データ開示等請求書」を郵送またはメール等にてお申込み下さい。（送付料は請求者のご負担となります。）
                <br />
                ご本人（または代理人）であることを確認した上で、ご希望の開示方法により回答いたします。
              </p>
            </li>
            <li className={styles.privacy_list}>
              <h4 className={styles.privacy_list_title}>（８）個人情報の安全管理のために講じた措置について</h4>
              <p className={styles.list_text}>
                当社では、個人情報を厳正に取り扱うため、個人情報保護方針を基に、個人情報に関する規定等を策定し、運用しております。
                <br />
                個人情報の適正な取扱いの確保のため、個人情報保護法及び同法ガイドラインに基づき、組織的・人的・物理的・技術的の4つの観点より安全管理措置を講じております。
              </p>
              <table className={styles.table}>
                <thead>
                  <tr className={styles.table_column_title}>
                    <th className={styles.th}>区分</th>
                    <th className={styles.th}>講じた措置</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th className={styles.th}>組織的対策</th>
                    <td className={styles.td}>全従業員を対象に年1回個人情報保護研修を実施しております。</td>
                  </tr>
                  <tr>
                    <th className={styles.th}>人的対策</th>
                    <td className={styles.td}>入社時に個人情報を含む機密保持契約書類を取得しております。</td>
                  </tr>
                  <tr>
                    <th className={styles.th}>物理的対策</th>
                    <td className={styles.td}>
                      従業者の入退室管理は「入退管理システム」を使いオフィスの解錠と施錠記録を管理しております。来訪者に対しては、入口で「受付システム」に社名、名前を記録しております。
                    </td>
                  </tr>
                  <tr>
                    <th className={styles.th}>技術的対策</th>
                    <td className={styles.td}>
                      アクセス権を持つIDは情報システム担当部門が発行・更新・廃棄の管理を行い、情報を使用しなくなったユーザーのアクセス権は直ちに抹消しております。
                    </td>
                  </tr>
                </tbody>
              </table>
            </li>
          </ul>
        </section>
      </article>
    </>
  )
}

export default SecurityPrivacy
